import {
    Box,
    Typography,
    Grid,
} from "@mui/material";
import Header from "../../common/Header";
import Card from "../../common/Card";
import CustomTable from "../../common/CustomTable";
import { useNavigation } from "../../../hooks/useNavigation";
import Button from "../../common/Button";
import { useMemo } from "react";

interface Column {
    id: string;
    label: string;
    minWidth?: number;
    align?: "right" | "center" | "left";
    format?: (value: number) => string;
}

interface Row {
    invoice: string;
    date: string;
    invoicePaidAmt: string;
    V3Commission: string;
    remainingAmt: string;
}

const rows: Row[] = [
    { invoice: "44575", date: "04/07/2024", invoicePaidAmt: "$250000.00", V3Commission: "$25000.00 (50%)", remainingAmt: "$7,566.00" },
    { invoice: "44575", date: "04/07/2024", invoicePaidAmt: "$250000.00", V3Commission: "$25000.00 (50%)", remainingAmt: "$7,566.00" },
];

const CommPayment = () => {

    const { navigate } = useNavigation();
    const columns: Column[] = useMemo(
        () => [
            { id: "invoice", label: "Invoice #", minWidth: 100 },
            { id: "date", label: "Date", minWidth: 100 },
            { id: "invoicePaidAmt", label: "Invoice Paid Amt", minWidth: 100 },
            { id: "V3Commission", label: "V3 Revenue", minWidth: 100 },
            { id: "remainingAmt", label: "Remaining Amt", minWidth: 100 },
        ],
        []
    );

    return (
        <Box sx={{
          margin: {
            xs: "20px 10px", 
            sm: "20px",
          },
        }}>
            <Header title="Service Fee Payment" subtitle="BILLING / SERVICE FEE PAYMENT" />
            <Box>
                <Card>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="body1">
                                <strong>Manufacturer :</strong> Parametrics
                            </Typography>
                        </Grid>
                    </Grid>
                    <Box sx={{ marginTop: 2 }}>
                        <CustomTable
                            columns={columns}
                            rows={rows}
                            disablePagination={true}
                            borderBox={true}
                        />
                    </Box>
                    <Box sx={{ textAlign: "right", marginTop: 2 }}>
                        <Typography variant="body1" fontWeight="bold">
                            $20,176.00
                        </Typography>
                    </Box>
                    <Grid container spacing={2} sx={{ marginTop: 2 }}>
                        <Grid item xs={6}>
                            <Typography variant="body1">
                                <strong>Total Service Fee %:</strong> 42.5%
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1">
                                <strong>Agency Service Fee:</strong> 32.5% Wound Biologics
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1">
                                <strong>Override Service Fee:</strong> 1.0% Bill Cochrane
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1">
                                <strong>Payment Month</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 3 }}>
                        <Button
                            color="success"
                            onClick={() => navigate("/invoice_list")}
                        >
                            Record Service Fee Payment
                        </Button>
                    </Box>
                </Card>
            </Box>
        </Box>
    );
};

export default CommPayment;
